var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.auditorList), function(item, index) {
    return _c('el-row', {
      key: item.id
    }, [_c('el-form', {
      ref: "ruleForm",
      refInFor: true,
      attrs: {
        "model": _vm.examineDetailsList[index],
        "rules": _vm.rules
      }
    }, [_c('el-divider', {
      attrs: {
        "content-position": "left"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "indeterminate": _vm.isIndeterminate[index]
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckAllChange(index)
        }
      },
      model: {
        value: (_vm.checkAll[index]),
        callback: function($$v) {
          _vm.$set(_vm.checkAll, index, $$v)
        },
        expression: "checkAll[index]"
      }
    }, [_vm._v("\n                    " + _vm._s("节点" + (item.node + 1)) + "\n                ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "prop": "staff_check"
      }
    }, [_c('el-checkbox-group', {
      on: {
        "change": function($event) {
          return _vm.handleCheckedCitiesChange(index)
        }
      },
      model: {
        value: (_vm.examineDetailsList[index].staff_check),
        callback: function($$v) {
          _vm.$set(_vm.examineDetailsList[index], "staff_check", $$v)
        },
        expression: "examineDetailsList[index].staff_check"
      }
    }, _vm._l((item.staffList), function(item1) {
      return _c('el-checkbox', {
        key: item1.id,
        attrs: {
          "label": item1.id
        }
      }, [_vm._v("\n                        " + _vm._s(item1.staff_name) + "\n                    ")])
    }), 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.id == null || _vm.id == ''),
      expression: "id == null || id == ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存\n        ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.id != null && _vm.id != ''),
      expression: "id != null && id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改\n        ")])], 1)], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcbdae5c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/SelectAuditor/SelectAuditor.vue
// module id = null
// module chunks = 